




























































































import sidebarMenu from './components/sidebarMenu.vue'
import breadcrumbNav from './components/breadcrumbNav.vue'
import axios from 'axios'
import {Component, Vue} from "vue-property-decorator";
import {State} from "vuex-class";

@Component({components: {sidebarMenu, breadcrumbNav}})
export default class main_farm extends Vue {
    $config: any;
    currentPageName = '';
    userName = sessionStorage.getItem('user');
    showFullScreenBtn = window.navigator.userAgent.indexOf('MSIE') < 0;
    isFullScreen = false;
    lockScreenSize = 0;
    colorList = ['#f56a00', '#7265e6', '#ffbf00', '#00a2ae'];
    color = '';

    get stmt() {
        return this.$store.state.stmt
    }

    set stmt(val) {
        this.$store.state.stmt = val
    }

    @State hideMenuText: boolean | undefined;
    @State pageOpenedList: any;
    @State currentPath: any;
    @State menuList: any;

    handleClickUserDropdown() {
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push({
            name: 'login'
        })
    }

    handleChange() {
        let i = this.$config.random(0, 3);
        this.color = this.colorList[i]
    }

    // 全屏
    handleFullScreen() {
        let doc: any = document;
        let main: any = document.getElementById('main')
        if (this.isFullScreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen()
            } else if (doc.mozCancelFullScreen) {
                doc.mozCancelFullScreen()
            } else if (doc.webkitCancelFullScreen) {
                doc.webkitCancelFullScreen()
            } else if (doc.msExitFullscreen) {
                doc.msExitFullscreen()
            }
        } else {
            if (main.requestFullscreen) {
                main.requestFullscreen()
            } else if (main.mozRequestFullScreen) {
                main.mozRequestFullScreen()
            } else if (main.webkitRequestFullScreen) {
                main.webkitRequestFullScreen()
            } else if (main.msRequestFullscreen) {
                main.msRequestFullscreen()
            }
        }
    }

    // 锁屏
    lockScreen() {
        let lockScreenBack: any = document.getElementById('lock_screen_back')
        lockScreenBack.style.transition = 'all 3s';
        lockScreenBack.style.zIndex = 10000;
        lockScreenBack.style.boxShadow = '0 0 0 ' + this.lockScreenSize + 'px #667aa6 inset';
        this.$store.commit('lock');
        let page_name: any = this.$route.name;
        sessionStorage.setItem('last_page_name', page_name); // 本地存储锁屏之前打开的页面以便解锁后打开
        setTimeout(() => {
            lockScreenBack.style.transition = 'all 0s';
            this.$router.push({
                name: 'locking'
            })
        }, 800)
    }

    init() {
        // 全屏相关
        document.addEventListener('fullscreenchange', () => {
            this.isFullScreen = !this.isFullScreen
        });
        document.addEventListener('mozfullscreenchange', () => {
            this.isFullScreen = !this.isFullScreen
        });
        document.addEventListener('webkitfullscreenchange', () => {
            this.isFullScreen = !this.isFullScreen
        });
        document.addEventListener('msfullscreenchange', () => {
            this.isFullScreen = !this.isFullScreen
        });
        // 锁屏相关
        let lockScreenBack: any = document.getElementById('lock_screen_back')
        let x = document.body.clientWidth;
        let y = document.body.clientHeight;
        let size = Math.sqrt(x * x + y * y);
        this.lockScreenSize = size;
        window.addEventListener('resize', () => {
            let x = document.body.clientWidth;
            let y = document.body.clientHeight;
            let size = Math.sqrt(x * x + y * y);
            this.lockScreenSize = size;
            lockScreenBack.style.transition = 'all 0s';
            lockScreenBack.style.width = lockScreenBack.style.height = size + 'px';
        })
        lockScreenBack.style.width = lockScreenBack.style.height = size + 'px';
        // 问候信息相关
        if (!sessionStorage.getItem('hasGreet')) {
            let now = new Date();
            let hour = now.getHours();
            let greetingWord = {
                title: '',
                words: ''
            };
            let userName = this.userName;
            if (hour < 6) {
                greetingWord = {
                    title: '凌晨好~' + userName,
                    words: '早起的鸟儿有虫吃~'
                }
            } else if (hour >= 6 && hour < 9) {
                greetingWord = {
                    title: '早上好~' + userName,
                    words: '来一杯咖啡开启美好的一天~'
                }
            } else if (hour >= 9 && hour < 12) {
                greetingWord = {
                    title: '上午好~' + userName,
                    words: '工作要加油哦~'
                }
            } else if (hour >= 12 && hour < 14) {
                greetingWord = {
                    title: '中午好~' + userName,
                    words: '午饭要吃饱~'
                }
            } else if (hour >= 14 && hour < 17) {
                greetingWord = {
                    title: '下午好~' + userName,
                    words: '下午也要活力满满哦~'
                }
            } else if (hour >= 17 && hour < 19) {
                greetingWord = {
                    title: '傍晚好~' + userName,
                    words: '下班没事问候下爸妈吧~'
                }
            } else if (hour >= 19 && hour < 21) {
                greetingWord = {
                    title: '晚上好~' + userName,
                    words: '工作之余品一品书香吧~'
                }
            } else {
                greetingWord = {
                    title: '深夜好~' + userName,
                    words: '夜深了，注意休息哦~'
                }
            }
            this.$Notice.config({
                top: 130
            });
            this.$Notice.info({
                title: greetingWord.title,
                desc: greetingWord.words,
                duration: 4,
                name: 'greeting'
            });
            sessionStorage.setItem('hasGreet', '1')
        }
    }

    agreement() {
        axios.put(`${this.$config.url}/dash/stmt`)
    }

    beforeunloadFn() {
        this.$store.commit('snippetTagToJson')
    }

    mounted() {
        this.handleChange();
        this.$store.commit('breadcrumb_set', this.$route.matched[1].name);
        this.$store.state.currentPageName = this.$route.matched[1].name;
        if (localStorage.getItem('pageOpenedList')) {
            let pageOpenedList: any = localStorage.getItem('pageOpenedList');
            this.$store.state.pageOpenedList = JSON.parse(pageOpenedList)
        } else {
            this.$store.state.pageOpenedList = [{
                title: '首页',
                path: '',
                name: 'home_index'
            }]
        }
        this.init();
    }

    created() {
        // 权限菜单过滤相关
        this.$store.commit('sidebar_filter');
        this.$store.commit('snippetTagFromJson');
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('jwt');
        window.addEventListener('beforeunload', () => this.beforeunloadFn())
    }

    destroyed() {
        window.removeEventListener('beforeunload', () => this.beforeunloadFn())
    }

}
